import { createFileRoute } from "@tanstack/react-router";
import { UsermanagementPage } from "@/pages/usermanagement/UsermanagementPage.tsx";

export const Route = createFileRoute("/_auth/_isAdmin/einstellungen/benutzer/")(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  return <UsermanagementPage />;
}
